const getOptionsFromFile = async (module, modelName, dataTableOptionsPath = null) => {
	let options = null
	if(modelName) {
		const path = dataTableOptionsPath || `${module}/${modelName.toLowerCase()}`
		try {
			const res = await import("@/data/"+path)
			options = res.default
			if(!options) { // if options are functions (in superadmin)
				for (const key in res) {
					if (typeof res[key] === 'function') {
						options = res[key]()
					}
				}
			}
		} catch(err) {
			console.log('error on import')
			console.error(err)
		}
	}
	return options
}

export { getOptionsFromFile }
